import React, { PropsWithChildren } from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import styles from "./style.module.css";
import type { TableColumnDefinition } from "~types/table";

type TableRowProps<T> = {
  columns: Array<TableColumnDefinition<T>>;
  rowData: T;
  className?: string;
};

export default function TableRow<T>(
  props: PropsWithChildren<TableRowProps<T>>
) {
  return (
    <tr className={createClasses(styles.tableRow, props.className)}>
      {props.children}
    </tr>
  );
}
